import * as React from "react";
import { forwardRef } from "react";
const FourthRowSeatsIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 24",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M11.238 7.398a.75.75 0 0 1 0 1.5h-1.75a.75.75 0 0 1 0-1.5h1.75ZM15.682 7.398a.75.75 0 0 1 0 1.5h-1.75a.75.75 0 0 1 0-1.5h1.75Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.63 1.473a3.494 3.494 0 0 1 3.497 3.49V6.05c.264.118.526.243.785.376l.45.24.066.041a.75.75 0 0 1-.792 1.272 14.656 14.656 0 0 0-.51-.269v13.143a2.123 2.123 0 0 1-2.122 2.12H7.898a2.123 2.123 0 0 1-2.123-2.12V7.936l-.196.11a.75.75 0 0 1-.76-1.292c.314-.185.634-.357.956-.517V4.964a3.494 3.494 0 0 1 3.497-3.491h6.359Zm1.997 5.584c-3.328-1.233-7.032-1.231-10.352.144v13.65c0 .342.278.622.623.622h9.106c.345 0 .623-.28.623-.621V7.057ZM9.272 2.973a1.994 1.994 0 0 0-1.997 1.99v.63c3.356-1.234 7.011-1.235 10.352-.127v-.502a1.994 1.994 0 0 0-1.996-1.991H9.272Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.878 14.704c.349.038.621.358.622.746 0 .388-.273.708-.622.746l-.07.004H9.391c-.382 0-.692-.336-.692-.75s.31-.75.692-.75h6.415l.07.004ZM15.878 18.404c.349.038.621.358.622.746 0 .388-.273.708-.622.746l-.07.004H9.391c-.382 0-.692-.336-.692-.75s.31-.75.692-.75h6.415l.07.004ZM15.878 11.004c.349.038.621.358.622.746 0 .388-.273.708-.622.746l-.07.004H9.391c-.382 0-.692-.336-.692-.75s.31-.75.692-.75h6.415l.07.004Z"
}));
const ForwardRef = forwardRef(FourthRowSeatsIcon);
export default ForwardRef;